export interface TeamToPhoneNumberModel {
  [key: string]: TeamNumberLanguageModel
}

interface TeamNumberLanguageModel {
  phone: string;
  displayPhone: string;
  mapsAddress: string;
  displayAddress: string;
  language: string;
  whatsappLink: string;
  whatsappLinkText: string;
}

interface LanguagesStringsModel {
  [key: string]: LanguageSpecificStringsModel
}

interface LanguageSpecificStringsModel {
  description: string;
  trustbox: string;
}

export const servedCountriesList: string[] = [
  'it',
  'gb',
  'us',
  'others'
]

export const TeamToPhoneNumber = {
  it: {
    sales_it: {
      phone: '+390697631527',
      displayPhone: '+39 (06) 97631527',
      mapsAddress: 'https://www.google.it/maps/place/Laeva+2,+10151+Tallinn,+Estonia/@59.4400201,24.754515,16z/data=!4m5!3m4!1s0x4692936727290ec3:0xa5169b23a5b3976d!8m2!3d59.440724!4d24.7572288',
      displayAddress: 'Voxloud oü, Laeva tn. 2, 10117 Tallin (EE)',
      language: 'italian',
      whatsappLink: 'https://wa.me/message/BHO3OQNYRPLLI1',
      whatsappLinkText: 'Scrivici su WhatsApp qui',
    },
    support_it: {
      phone: '+390640048260',
      displayPhone: '+39 (06) 40048260',
      mapsAddress: 'https://www.google.it/maps/place/Laeva+2,+10151+Tallinn,+Estonia/@59.4400201,24.754515,16z/data=!4m5!3m4!1s0x4692936727290ec3:0xa5169b23a5b3976d!8m2!3d59.440724!4d24.7572288',
      displayAddress: 'Voxloud oü, Laeva tn. 2, 10117 Tallin (EE)',
      language: 'italian',
      whatsappLink: '',
      whatsappLinkText: '',
    },
    marketing_it: {
      phone: '+390640410826',
      displayPhone: '+39 (06) 40410826',
      mapsAddress: 'https://www.google.it/maps/place/Laeva+2,+10151+Tallinn,+Estonia/@59.4400201,24.754515,16z/data=!4m5!3m4!1s0x4692936727290ec3:0xa5169b23a5b3976d!8m2!3d59.440724!4d24.7572288',
      displayAddress: 'Voxloud oü, Laeva tn. 2, 10117 Tallin (EE)',
      language: 'italian',
      whatsappLink: '',
      whatsappLinkText: '',
    },
    partner_it: {
      phone: '+390640060312',
      displayPhone: '+39 (06) 40060312',
      mapsAddress: 'https://www.google.it/maps/place/Laeva+2,+10151+Tallinn,+Estonia/@59.4400201,24.754515,16z/data=!4m5!3m4!1s0x4692936727290ec3:0xa5169b23a5b3976d!8m2!3d59.440724!4d24.7572288',
      displayAddress: 'Voxloud oü, Laeva tn. 2, 10117 Tallin (EE)',
      language: 'italian',
      whatsappLink: 'https://wa.me/message/HKLGDT34EKQVN1',
      whatsappLinkText: 'Scrivici su WhatsApp qui',
    }
  },
  gb: {
    sales_gb: {
      phone: '+442037691920',
      displayPhone: '+44 (20) 37691920',
      mapsAddress: 'https://www.google.it/maps/search/Rolt+house,+Coventry+Canal+Basin,+St+Nicholas+St,+Coventry+CV1+4LY,+United+Kingdom/@52.41289,-1.5144082,17z/data=!3m1!4b1?hl=it',
      displayAddress: 'Voxloud LTD, Rolt house, Coventry Canal Basin, St. Nicolas Street, Coventry, West Midlands, CV1 4LY',
      language: 'english'
    },
    support_gb: {
      phone: '+442037690629',
      displayPhone: '+44 (20) 37690629',
      mapsAddress: 'https://www.google.it/maps/search/Rolt+house,+Coventry+Canal+Basin,+St+Nicholas+St,+Coventry+CV1+4LY,+United+Kingdom/@52.41289,-1.5144082,17z/data=!3m1!4b1?hl=it',
      displayAddress: 'Voxloud LTD, Rolt house, Coventry Canal Basin, St. Nicolas Street, Coventry, West Midlands, CV1 4LY',
      language: 'english'
    },
    marketing_gb: {
      phone: '+442037690537',
      displayPhone: '+44 (20) 37690537',
      mapsAddress: 'https://www.google.it/maps/search/Rolt+house,+Coventry+Canal+Basin,+St+Nicholas+St,+Coventry+CV1+4LY,+United+Kingdom/@52.41289,-1.5144082,17z/data=!3m1!4b1?hl=it',
      displayAddress: 'Voxloud LTD, Rolt house, Coventry Canal Basin, St. Nicolas Street, Coventry, West Midlands, CV1 4LY',
      language: 'english'
    }
  },
  us: {
    sales_us: {
      phone: '+12126600227',
      displayPhone: '+1 (212) 6600227',
      mapsAddress: 'https://goo.gl/maps/eLmkPTfMSTGocPPe7',
      displayAddress: 'Voxloud, 175 S. Third Street Suite # 1050, 43215 Columbus, Ohio',
      language: 'english'
    },
    support_us: {
      phone: '+19179098338',
      displayPhone: '+1 (917) 9098338',
      mapsAddress: 'https://goo.gl/maps/eLmkPTfMSTGocPPe7',
      displayAddress: 'Voxloud, 175 S. Third Street Suite # 1050, 43215 Columbus, Ohio',
      language: 'english'
    },
    marketing_us: {
      phone: '+19179098972',
      displayPhone: '+1 (917) 9098972',
      mapsAddress: 'https://goo.gl/maps/eLmkPTfMSTGocPPe7',
      displayAddress: 'Voxloud, 175 S. Third Street Suite # 1050, 43215 Columbus, Ohio',
      language: 'english'
    }
  },
  others: {
    other_teams: {
      phone: '+3728807679',
      displayPhone: '+372 8807679',
      mapsAddress: 'https://www.google.it/maps/place/Laeva+2,+10151+Tallinn,+Estonia/@59.4400201,24.754515,16z/data=!4m5!3m4!1s0x4692936727290ec3:0xa5169b23a5b3976d!8m2!3d59.440724!4d24.7572288',
      displayAddress: 'Voxloud oü, Laeva tn. 2, 10117 Tallin (EE)',
      language: 'english'
    }
  }
}



const languageSpecificStrings: LanguagesStringsModel = {
  italian: {
    description: "Ottieni un numero fisso e un centralino telefonico in cloud, in 59 secondi!",
    trustbox: `<p style="text-decoration: none;">
      <a href="https://it.trustpilot.com/review/voxloud.com?utm_medium=Trustbox&utm_source=EmailSignature4" target="_blank" rel="noopener noreferrer" style="text-decoration:none;text-underline: none;"><img src="https://emailsignature.trustpilot.com/signature/it-IT/4/5cb9f717001a030001a8057e/text.png" border="0" height="20" style="max-height: 20px;border: none;" alt="Trustpilot Human score"></a> &nbsp;
      <a href="https://it.trustpilot.com/review/voxloud.com?utm_medium=Trustbox&utm_source=EmailSignature4" target="_blank" rel="noopener noreferrer" style="text-decoration:none;text-underline: none;"><img src="https://emailsignature.trustpilot.com/signature/it-IT/4/5cb9f717001a030001a8057e/stars.png" border="0" height="20" style="max-height: 20px;border: none;" alt="Trustpilot Stars"></a> &nbsp;
      <a href="https://it.trustpilot.com/review/voxloud.com?utm_medium=Trustbox&utm_source=EmailSignature4" target="_blank" rel="noopener noreferrer" style="text-decoration:none;text-underline: none;"><img src="https://emailsignature.trustpilot.com/brand/s/4/logo.png" border="0" height="20" style="max-height: 20px;border: none;" alt="Trustpilot Logo"></a>
      </p>`
  },
  english: {
    description: "Get your cloud phone system in just 59 seconds.",
    trustbox: `<p style="text-decoration: none;"> 
      <a href="https://www.trustpilot.com/review/voxloud.com?utm_medium=Trustbox&utm_source=EmailSignature4" target="_blank" rel="noopener noreferrer" style="text-decoration:none;text-underline: none;"><img src="https://emailsignature.trustpilot.com/signature/en-US/4/5cb9f717001a030001a8057e/text.png" border="0" height="20" style="max-height: 20px;border: none;" alt="Trustpilot Human score"></a> &nbsp;
      <a href="https://www.trustpilot.com/review/voxloud.com?utm_medium=Trustbox&utm_source=EmailSignature4" target="_blank" rel="noopener noreferrer" style="text-decoration:none;text-underline: none;"><img src="https://emailsignature.trustpilot.com/signature/en-US/4/5cb9f717001a030001a8057e/stars.png" border="0" height="20" style="max-height: 20px;border: none;" alt="Trustpilot Stars"></a> &nbsp;
      <a href="https://www.trustpilot.com/review/voxloud.com?utm_medium=Trustbox&utm_source=EmailSignature4" target="_blank" rel="noopener noreferrer" style="text-decoration:none;text-underline: none;"><img src="https://emailsignature.trustpilot.com/brand/s/4/logo.png" border="0" height="20" style="max-height: 20px;border: none;" alt="Trustpilot Logo"></a>
      </p>`
  }
}

export function getSignCode(imageUrl: string, name: string, role: string, team: TeamNumberLanguageModel): string {
  const hasWhatsapp = team.whatsappLink !== '' && team.whatsappLinkText !== '';
  const hasTr = hasWhatsapp ? 
  `<tr> 
    <td style="margin: 0; vertical-align: middle;">
      <img alt="WhatsApp icon"
        src="https://www.voxloud.com/wp-content/themes/voxloud/dist/img/whatsapp.png"
        style="vertical-align: -1px; padding-right: 5px;" width="15">
      <a color="#000000" href="${team.whatsappLink}"
       style="height: 20px; line-height: 1; vertical-align: middle; color: rgb(0,0,0);font-size: 12px"
       target="_blank">${team.whatsappLinkText}</a>
    </td>
  </tr>` : '';

  return `<table bgcolor="#ffffff" border="0" cellpadding="0" cellspacing="0"
style="border-collapse: collapse;" width="600">
<tbody>
  <tr>
      <td style="padding: 25px; margin: 0; text-align: center; width: 128px;">
          <table border="0" cellpadding="0" cellspacing="0" width="128">
              <tbody>
                  <tr>
                      <td style="padding: 0; margin: 0;">
                          <img alt="Avatar" width="125"
                              src="${imageUrl}">
                      </td>
                  </tr>
                  <tr>
                      <td style="padding: 0; margin: 0;">
                          <img alt="Voxloud logo" height="26"
                              src="https://www.voxloud.com/wp-content/themes/voxloud/dist/img/logo/wordmark/voxloud-wordmark_@3x.png"
                              width="125">
                      </td>
                  </tr>
              </tbody>
          </table>
      </td>
      <td style="padding: 0; margin: 0; width: 400px;">
          <table border="0" cellpadding="0" cellspacing="0" width="400">
              <tbody>
                  <tr>
                      <td 
                          style="margin: 0; font-family:Helvetica, Arial, sans-serif; font-size:18px; font-weight: 700; color: #000000; line-height: 1;">
                          <span _ngcontent-ovo-37="">${name}</span>
                      </td>
                  </tr>
                  <tr>
                      <td bordercolor="#000000"
                          style="padding-bottom: 5px; margin: 0; border-bottom: 1px solid #000000; font-family:Helvetica, Arial, sans-serif; font-size:16px; color: #000000; line-height: 1;">
                          <span _ngcontent-ovo-37="">${role}</span>
                      </td>
                  </tr>
                  <tr>
                      <td style="padding-top: 10px; margin: 0; vertical-align: middle;">
                          <img alt="Phone icon"
                              src="https://www.voxloud.com/wp-content/themes/voxloud/dist/img/phone.png"
                              style="padding-right: 5px;" width="13">
                          <a color="#000000" href="tel:${team.phone}"
                              style="height: 20px; line-height: 1; vertical-align: middle; color: rgb(0,0,0);font-size: 12px"
                              target="_blank">${team.displayPhone}</a>
                      </td>
                  </tr>
                  ${hasTr}
                  <tr>
                      <td style="padding: 0; margin: 0; vertical-align: middle;">
                          <img alt="Map marker icon"
                              src="https://www.voxloud.com/wp-content/themes/voxloud/dist/img/map-marker.png"
                              style="padding-right: 5px;" width="13">
                          <a color="#000000"
                              href="${team.mapsAddress}"
                              rel="noopener noreferrer"
                              style="height: 20px; line-height: 1; vertical-align: middle; color: rgb(0,0,0);font-size: 12px"
                              target="_blank">${team.displayAddress}</a>
                      </td>
                  </tr>
                  <tr>
                      <td style="padding: 5px 0; margin: 0;">
                          <a color="#ffffff" href="https://www.voxloud.com"
                              rel="noopener noreferrer"
                              style="font-weight: 700; display: inline-block; padding: 10px 5px; text-align: center; line-height: 1; vertical-align: middle; color: #ffffff; font-size: 12px; border-radius: 6px; background-color: #ff3465; border-style: solid; border-width: 1px; border-color: #ff3465; text-decoration: none !important;"
                              target="_blank">${languageSpecificStrings[team.language].description}</a>
                      </td>
                  </tr>
                  <tr>
                      <td style="padding: 0; margin: 0;">
                      ${languageSpecificStrings[team.language].trustbox}
                      </td>
                  </tr>
              </tbody>
          </table>
      </td>
  </tr>
</tbody>
</table>`;
};